module.exports = __webpack_public_path__ + "static/media/cq_ordine_tempo2 b.2b5e73d0.svg";